import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './ConfigService';
import { AuthenticationService } from './authentication.service';
import { UriApi } from '../helpers/UriApi';
import { Constants } from '../helpers/constants';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  api_getData = ConfigService.apiUrl + "/CommonMst/GetData";
  api_excute_sp = ConfigService.apiUrl + "/Common/execute-sp";
  api_getDataAuth = ConfigService.apiUrl + "/CommonMst/GetDataAuthorize";
  api_post_common = ConfigService.apiUrl + "/Setting/PostData";
  today = new Date();

  body = {
    request: {
      jsonParams: {},
      functionCode: 109,
      data: "",
      dataList: "",
      menuCd: '',
    }
  };

  body_sp = {
    viewModel: "",
    storedProcedure: "",
    parameters: {

    },
    sorts: [
      {
        column: "",
        direction: ""
      }
    ],
    paging: {
      page: 0,
      pageSize: 0
    }
  }

  constructor(private http: HttpClient, private messageService: MessageService, private translate: TranslateService,
    private auth: AuthenticationService
  ) { }

  showError(content: any) {
    const formatted = content.replace(/\.\s*/g, '.\n');
    this.messageService.add({ key: 'global', severity: 'error', summary: this.translate.instant('ERR'), detail: formatted, life: 3000 });
  }

  showSuccess(content: any) {
    const formatted = content.replace(/\.\s*/g, '.\n');
    this.messageService.add({ key: 'global', severity: 'success', summary: this.translate.instant('SUCCESS'), detail: formatted, life: 3000 });
  }

  showCartTemp(): Promise<boolean> {
    return new Promise((resolve) => {
      this.messageService.add({
        key: 'cart',
        severity: 'warn',
        detail: this.translate.instant('SYSMESER0032'),
        sticky: true,
        data: {
          onContinue: () => {
            this.messageService.clear('cart');
            resolve(true);
          }
        }
      });
    });
  }

  hideCartTemp() {
    this.messageService.clear('cart');
  }

  // uploadFile(data: any): Promise<{ url: string }> {
  //   return new Promise((resolve, reject) => {
  //     const formData = new FormData();
  //     formData.append('file', data[0]);
  //     this.http.post(UriApi.api_upload, formData).subscribe((res: any) => {
  //       if (res?.isOK) {
  //         resolve({ url: res?.result?.dataRes?.path })
  //       }
  //       else {
  //         reject(res?.errorMessages)
  //       }
  //     })
  //   })
  // }


  getData(functionCode: number, jsonParams = {}) {
    this.body.request.functionCode = functionCode;
    this.body.request.jsonParams = jsonParams;

    return this.http.post(this.api_getData, this.body);
  }

  excute_sp(storedProcedure: string, param: any = {}) {
    this.body_sp.storedProcedure = storedProcedure;
    this.body_sp.parameters = param

    return this.http.post(this.api_excute_sp, this.body_sp);
  }

  getComm(COM_H_CD: string, COM_D_CD: string = "") {
    this.body_sp.storedProcedure = "6a8398cf-298d-11f1-9014-00155d001e02";
    this.body_sp.parameters = { P_COMM_H_CD: COM_H_CD }

    return this.http.post(this.api_excute_sp, this.body_sp);
  }

  getUserInfo() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_USER_ID: this.auth.getUserId()
    }

    this.body_sp.storedProcedure = '6a839fdf-298d-11f1-9014-00155d001e02';
    this.body_sp.parameters = param

    return this.http.post(this.api_excute_sp, this.body_sp);
  }

  excute_spNoLoading(storedProcedure: string, param: any = {}): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      this.body_sp.storedProcedure = storedProcedure;
      this.body_sp.parameters = param
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(this.api_excute_sp, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(this.body_sp),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  getCommNoLoading(COM_H_CD: string, COM_D_CD: string = ""): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      this.body_sp.storedProcedure = "6a8398cf-298d-11f1-9014-00155d001e02";
      this.body_sp.parameters = { P_COMM_H_CD: COM_H_CD }
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(this.api_excute_sp, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(this.body_sp),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  getDataAuth(functionCode: number, jsonParams = {}) {
    this.body.request.functionCode = functionCode;
    this.body.request.jsonParams = jsonParams;

    return this.http.post(this.api_getDataAuth, this.body);
  }

  postData(functionCode: number, jsonParams = {}) {
    this.body.request.functionCode = functionCode;
    this.body.request.jsonParams = jsonParams;

    return this.http.post(this.api_post_common, this.body);
  }

  // getMenu() {
  //   this.body.request.functionCode = 101;
  //   this.body.request.jsonParams = '{"p_option":1}';

  //   return this.http.post(UriApi.api_Menu_get, this.body);
  // }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getMenu() {
    return this.http.post(UriApi.api_Menu_get, this.body);
  }

  getDateNow(num: number = 0) {
    let date: Date = new Date();
    date.setDate(date.getDate() + num);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatToHHMM(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  formatTime(v: number | string): string {
    if (v) {
      const s = v.toString().padStart(4, '0');
      return `${s.slice(0, 2)}:${s.slice(2, 4)}:00`;
    }
    else return '';
  }

  formatTime2(v: number | string): string {
    if (v) {
      const s = v.toString().padStart(6, '0');
      return `${s.slice(0, 2)}:${s.slice(2, 4)}:${s.slice(4, 6)}`;
    }
    else return '';
  }

  formatStringDateYYYMMDDHHMMSS(dateString: any): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string");
    }

    date.setHours(date.getHours() + 9);

    const pad = (num: number) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const lang = Constants.getLang();

    const ret = lang.toUpperCase() == 'KO' ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` :
      lang.toUpperCase() == 'VI' ? `${day}-${month}-${year} ${hours}:${minutes}:${seconds}` : `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
    return ret;
  }

  formatStringDateYYYMMDDHHMMSSUTC0(dateString: any): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string");
    }

    const pad = (num: number) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const lang = Constants.getLang();

    const ret = lang.toUpperCase() == 'KO' ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` :
      lang.toUpperCase() == 'VI' ? `${day}-${month}-${year} ${hours}:${minutes}:${seconds}` : `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr || dateStr.length !== 14) return '';

    const year = parseInt(dateStr.substring(0, 4));
    const month = parseInt(dateStr.substring(4, 6)) - 1;
    const day = parseInt(dateStr.substring(6, 8));
    const hour = parseInt(dateStr.substring(8, 10));
    const minute = parseInt(dateStr.substring(10, 12));
    const second = parseInt(dateStr.substring(12, 14));

    const utcDate = new Date(year, month, day, hour, minute, second);

    utcDate.setUTCHours(utcDate.getUTCHours() + 9);

    const y = utcDate.getFullYear();
    const m = String(utcDate.getMonth() + 1).padStart(2, '0');
    const d = String(utcDate.getDate()).padStart(2, '0');
    const h = String(utcDate.getHours()).padStart(2, '0');
    const min = String(utcDate.getMinutes()).padStart(2, '0');
    const s = String(utcDate.getSeconds()).padStart(2, '0');

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  formatDate(date: Date): string {
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().split('T')[0];
  }

  formatStringDateToDate(date: string): Date {
    const s = date.toString();

    const year = +s.slice(0, 4);
    const month = +s.slice(4, 6) - 1;
    const day = +s.slice(6, 8);

    return new Date(year, month, day);
  }

  formatDateYYYYMMDD(dateString: any): string {
    const date = new Date(dateString);
    const pad = (num: any) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}`;
  }

  formatDateStringYYYYMMDD(dateString: string): string {
    if (!dateString) return '';

    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    return `${year}-${month}-${day}`;
  }

  formatDateStringYYYYMMDDHHMMSS(dateString: string): string {
    if (!dateString) return '';

    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    const hour = dateString.substring(8, 10);
    const min = dateString.substring(10, 12);
    const sec = dateString.substring(12, 14);

    return `${year}-${month}-${day} ${hour}:${min}:${sec} `;
  }

  formatDateYYYYMMDD2(dateString: any): string {
    const date = new Date(dateString);
    const pad = (num: any) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}${month}${day}`;
  }

  formatDateYYYYMMDD3(dateString: any): string {
    const date = new Date(dateString);
    const pad = (num: any) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}`;
  }

  formatDateYYYYMMDD4(date: Date): string {
  if (!date) return '';

  const pad = (num: number) => num.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  return `${year}${month}${day}`;
}

  formatDateYMD(value: string): string {
    if (!value || value.length !== 8) return value;
    return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`;
  }

  fromatDateYYYYMMDDByLang(dateString: any) {
    const date = new Date(dateString);
    const pad = (num: any) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const lang = Constants.getLang();

    const ret = lang.toUpperCase() == 'KO' ? `${year}-${month}-${day}` :
      lang.toUpperCase() == 'VI' ? `${day}-${month}-${year}` : `${month}-${day}-${year}`;
    return ret

  }

  formatNum(value: number) {
    return new Intl.NumberFormat('en-US').format(value);
  }

  copyText(text: string) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.showSuccess(Constants.getLang() == 'ko' ? '복사 성공' : 'Copy success');
        })
        .catch((err) => {
          console.error('Copy failed', err);
          this.showError('Copy failed.');
        });
    } else {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (successful) {
          this.showSuccess(Constants.getLang() == 'ko' ? '복사 성공' : 'Copy success');
        } else {
          this.showError('Copy failed.');
        }
      } catch (err) {
        console.error('Fallback: Copy failed', err);
        this.showError('Copy failed.');
      }
    }
  }

  postDataMasterNoLoading(functionCode: number, jsonParams: any = {}): Promise<{ res: any }> {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      this.body.request.functionCode = functionCode;
      this.body.request.jsonParams = jsonParams;
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_master_post, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(this.body),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  uploadFile(data: any): Promise<{ url: string, thumbnail: string }> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', data[0]);
      this.http.post(UriApi.api_upload, formData).subscribe((res: any) => {
        if (res?.isOK) {
          resolve({ url: res?.result?.dataRes?.path, thumbnail: res?.result?.dataRes?.thumbnailPath })
        }
        else {
          reject(res?.errorMessages)
        }
      })
    })
  }

  uploadFiles(data: any): Promise<{ data: any }> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      data.forEach((file: any) => {
        formData.append('files', file);
      });
      this.http.post(UriApi.api_uploads, formData).subscribe((res: any) => {
        if (res?.isOK) {
          resolve({ data: res })
        }
        else {
          reject(res?.errorMessages)
        }
      })
    })
  }

  base64ToBytes(base64: string): Uint8Array {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
  }

  // removeEscPos(bytes: Uint8Array): Uint8Array {
  //   const result: number[] = [];

  //   for (let i = 0; i < bytes.length; i++) {
  //     // ESC (0x1B)
  //     if (bytes[i] === 0x1B) {
  //       i += 2; // skip command (đa phần ESC + 2 byte)
  //       continue;
  //     }

  //     result.push(bytes[i]);
  //   }

  //   return new Uint8Array(result);

  // }

  parseEscPos(bytes: Uint8Array) {
    const lines: { text: string; align: string }[] = [];

    let currentLine: number[] = [];
    let align: 'left' | 'center' | 'right' = 'left';

    for (let i = 0; i < bytes.length; i++) {

      // ESC
      if (bytes[i] === 0x1B) {
        const cmd = bytes[i + 1];

        if (cmd === 0x61) {
          const mode = bytes[i + 2];

          if (mode === 0x00) align = 'left';
          else if (mode === 0x01) align = 'center';
          else if (mode === 0x02) align = 'right';

          i += 2;
          continue;
        }

        if (
          cmd === 0x45 ||
          cmd === 0x64 ||
          cmd === 0x2D ||
          cmd === 0x21
        ) {
          i += 2;
          continue;
        }

        i += 1;
        continue;
      }

      // newline
      if (bytes[i] === 0x0A) {
        const text = new TextDecoder('euc-kr').decode(new Uint8Array(currentLine));
        lines.push({ text, align });
        currentLine = [];
        continue;
      }

      currentLine.push(bytes[i]);
    }

    return lines;
  }

  removeEscPos(bytes: Uint8Array): Uint8Array {
    const result: number[] = [];

    for (let i = 0; i < bytes.length; i++) {
      // ESC
      if (bytes[i] === 0x1B) {
        const cmd = bytes[i + 1];

        switch (cmd) {
          case 0x61: // align
          case 0x45: // bold
          case 0x64: // feed
          case 0x2D: // underline
          case 0x21: // size
            i += 2;
            continue;

          default:
            i += 1;
            continue;
        }
      }

      // GS ! (size)
      if (bytes[i] === 0x1D && bytes[i + 1] === 0x21) {
        i += 2;
        continue;
      }

      result.push(bytes[i]);
    }

    return new Uint8Array(result);
  }

  getAllEmployee(storeId: any) {
    return this.http.get(UriApi.api_getallEmployee, { params: { storeId: storeId } });
  }

  getCalendarKey() {
    return this.http.get(UriApi.api_CalendarKey_get);
  }

  base64ToFile(base64: string, fileName: string): File {
    const [header, data] = base64.split(',');
    const mimeMatch = header.match(/data:(.*?);base64/);
    const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

    const binary = atob(data);
    const len = binary.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return new File([bytes], fileName, { type: mimeType });
  }
}
